<h3 *ngIf="showTitle">Actions History</h3>
<h3 *ngIf="showName">{{ userInfo?.name }}</h3>

<div class="row">
	<div class="col-6">
		<label for="">Date Range:</label>
		<app-form-range-date style="width: 100%" [(ngModel)]="dateRange_" (OnSelected)="getUserActions()" [position]="'left'" [range_type]="'RANGE_PAST'" [autoApply]="true"></app-form-range-date>
	</div>
	<div class="col-6" align="right">
		<button (click)="exportActionsToPDF()" type="button" class="btn btn-danger btn-label waves-effect waves-light export-btn">
			<i class="bx bxs-file-pdf label-icon align-middle fs-16 me-2"></i>
			Export
		</button>
	</div>
</div>
<hr />
<div id="loginHistoryTable">
	<ngx-datatable #table class="material" [columnMode]="ColumnMode.force" [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [rows]="actions" [limit]="10000">
		<ngx-datatable-column name="#" headerClass="cell-center title-header" cellClass="cell-center" [width]="65">
			<ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
				{{ rowIndex + 1 }}
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column name="Action description" headerClass="title-header" [width]="400">
			<ng-template let-row="row" ngx-datatable-cell-template>
				<div style="text-align: justify">
					{{ row.action_description ? row.action_description : "-" }}
				</div>
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="Date and time" headerClass="title-header" [width]="250">
			<ng-template let-row="row" ngx-datatable-cell-template>
				<div>
					{{ row.date_time | utcToLocal : "MMM d, y, h:mm a" }}
				</div>
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="IpV4" headerClass="title-header" [width]="250">
			<ng-template let-row="row" ngx-datatable-cell-template>
				<div>
					{{ row.ipv4 && row.ipv4 !== "undefined" ? row.ipv4 : "-" }}
				</div>
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="IpV6" headerClass="title-header" [width]="350">
			<ng-template let-row="row" ngx-datatable-cell-template>
				<div>
					{{ row.ipv6 && row.ipv6 !== "undefined" ? row.ipv6 : "-" }}
				</div>
			</ng-template>
		</ngx-datatable-column>
	</ngx-datatable>
</div>
